import {EnumHelper} from "../../../helpers/enumHelper";
import DetailViewContentElement from "./detailViewContentElement";
import {DetailViewContentElementCapability} from "./detailViewContentElementCapability";
import assertNever from "../../../../global/assetNever";
import {DetailViewContentElementType} from "~/enums/detailViews/detailViewContentElementType";
import { InputFormatType } from "../../../../formability/form_builder/models/inputFormatType";
import {ListFormatType} from '~/enums/listFormatType'

export default class DetailViewContentElementCapabilityManager {
  static debug: boolean = false;

  static addDefaultProperties(m: DetailViewContentElement): void {
    // done this way so a case statement can use assertNever to ensure all capabilities are accounted for
    EnumHelper.toArray(DetailViewContentElementCapability).forEach((c: DetailViewContentElementCapability) => {
      switch (c) {
        case DetailViewContentElementCapability.labelable:
          // Do nothing Defined on base model
          break;
        case DetailViewContentElementCapability.selectable:
          // Do nothing
          break;
        case DetailViewContentElementCapability.lockable:
          // Do nothing
          break;
        case DetailViewContentElementCapability.helpTextable:
          // Do nothing Defined on base model
          break;
        case DetailViewContentElementCapability.dynamicLabelable:
          break;
        case DetailViewContentElementCapability.visibilityConditionable:
          m.defineProperty('visible', true);
          break;
        case DetailViewContentElementCapability.formattable:
          let formatType = InputFormatType.None;
          m.defineProperty('format_type', formatType)
          break;
        case DetailViewContentElementCapability.listFormattable:
          m.defineProperty('list_format_type', ListFormatType.Comma)
          break;
        default:
          assertNever(c);
          break;
      }
    });
  }

  static can(type: DetailViewContentElementType, duty: DetailViewContentElementCapability) {
    let can: boolean = false;
    switch (duty) {
      case DetailViewContentElementCapability.labelable:
        can = this.LABELABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.selectable:
        can = this.SELECTABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.lockable:
        can = this.LOCKABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.helpTextable:
        can = this.HELPTEXTABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.dynamicLabelable:
        can = this.DYNAMIC_LABELABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.visibilityConditionable:
        can = this.VISIBILITY_CONDITIONABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.formattable:
        can = this.FORMATTABLE_CONTROLS.includes(type);
        break;
      case DetailViewContentElementCapability.listFormattable:
        can = this.LIST_FORMATTABLE_CONTROLS.includes(type);
        break;
      default:
        assertNever(duty);
        can = false;
        break;
    }
    DetailViewContentElementCapabilityManager.log(`Type ${DetailViewContentElementType[type]} ${can ? 'can' : 'can\'t'} ${DetailViewContentElementCapability[duty]}`);
    return can;
  }
  private static log(message: string) {
    if (this.debug) {
      console.log(`DEBUG: DetailViewContentElementCan: ${message}`);
    }
  }
  static LABELABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.RelatedObject,
    DetailViewContentElementType.ModelProperty,
    DetailViewContentElementType.FormList,
    DetailViewContentElementType.FileProperty,
    DetailViewContentElementType.RelationSection,
  ];

  static DYNAMIC_LABELABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.PageTitle,
  ];


  static HELPTEXTABLE_CONTROLS: DetailViewContentElementType[]=[
    DetailViewContentElementType.PageSubtitle,
    DetailViewContentElementType.PageTitle,
    DetailViewContentElementType.FormList,
  ];

  static LOCKABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.PageTitle,
    DetailViewContentElementType.Header,
    DetailViewContentElementType.PageSubtitle,
  ];

  static SELECTABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.Header,
    DetailViewContentElementType.PageTitle,
    DetailViewContentElementType.PageSubtitle,
    DetailViewContentElementType.Actions,
    DetailViewContentElementType.RelatedObject,
    DetailViewContentElementType.ModelProperty,
    DetailViewContentElementType.TextArea,
    DetailViewContentElementType.DocumentLink,
    DetailViewContentElementType.ModelHistory,
    DetailViewContentElementType.Heading,
    DetailViewContentElementType.Subheading,
    DetailViewContentElementType.Grid,
    DetailViewContentElementType.Stack,
    DetailViewContentElementType.Divider,
    DetailViewContentElementType.TabBreak,
    DetailViewContentElementType.FormList,
    DetailViewContentElementType.FileProperty,
    DetailViewContentElementType.RelationSection,
  ];

  static VISIBILITY_CONDITIONABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.Heading,
    DetailViewContentElementType.Subheading,
    DetailViewContentElementType.TextArea,
    DetailViewContentElementType.ModelProperty,
    DetailViewContentElementType.RelatedObject,
    DetailViewContentElementType.DocumentLink,
    DetailViewContentElementType.ModelHistory,
    DetailViewContentElementType.FormList,
    DetailViewContentElementType.FileProperty,
    DetailViewContentElementType.Stack,
    DetailViewContentElementType.Grid,
    DetailViewContentElementType.Divider,
    DetailViewContentElementType.TabBreak,
  ];

  static FORMATTABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.ModelProperty,
  ];

  static LIST_FORMATTABLE_CONTROLS: DetailViewContentElementType[] = [
    DetailViewContentElementType.ModelProperty,
  ];
}
